import { render, staticRenderFns } from "./menuBar.vue?vue&type=template&id=66041cdd&"
import script from "./menuBar.vue?vue&type=script&lang=js&"
export * from "./menuBar.vue?vue&type=script&lang=js&"
import style0 from "./menuBar.vue?vue&type=style&index=0&id=66041cdd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports